import { render, staticRenderFns } from "./HareketTuru.vue?vue&type=template&id=24e87fb7"
import script from "./HareketTuru.vue?vue&type=script&lang=js"
export * from "./HareketTuru.vue?vue&type=script&lang=js"
import style0 from "./HareketTuru.vue?vue&type=style&index=0&id=24e87fb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports